<script setup>

import {computed, reactive} from "vue"

import InputRadio from "@shared/components/atoms/form/InputRadio.vue"
import useHelpers from "@shared/composables/useHelpers"
import {useNotificationsStore} from "@shared/stores/NotificationsStore"

const state = reactive({
    type: 'all',
    selectedNotificationId: null
})

const { formatDate } = useHelpers()

const notificationStore = useNotificationsStore()

const filteredNotifications = computed(() =>
    notificationStore.getNotificationsByType(state.type)
)

</script>

<template>
    <div
        v-if="notificationStore.isNotificationsModalVisible"
        id="divAppUserNotifications"
        class="show"
    >
        <div class="divUserNotificationsOverlay"></div>
        <div class="divUserNotificationsPopup">
            <div class="divUserNotificationsHeading">User Inbox</div>
            <div
                id="btnCloseUserNotifications"
                @click="notificationStore.setNotificationsModalVisibility(false)"
            />
            <div class="divNotificationColumnHeading">Messages</div>
            <div id="divUserNotifications">
                <div
                    v-for="notification in filteredNotifications"
                    :class="{
                        divNotification: true,
                        show: notification.id === state.selectedNotificationId
                    }"
                    :key="`notification-${notification.id}`"
                    @click="state.selectedNotificationId = notification.id"
                >
                    <div class="divNotificationDateSubject">
                        {{ formatDate(notification.created_at) }}
                        <template v-if="notification.subject">
                            - <b>{{ notification.subject }}</b>
                        </template>
                    </div>
                    <div class="divNotificationMessage">{{ notification.message }}</div>
                </div>
            </div>

            <div class="divNotificationTypes">
                <InputRadio
                    v-model="state.type"
                    :options="{
                        all: 'All',
                        allocation: 'Allocation',
                        cashback: 'Cashback',
                        withdraw: 'Withdraw',
                        win: 'Win',
                        other: 'Other'
                    }"
                />
            </div>
        </div>
    </div>
</template>
